import { Modal } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { FailIcon } from "@/config/config";
import { CommonNormalBtn, CommonPrimaryBtn } from "@/components/CommonBtn";
import { useRouter } from "next/router";
import useDispatchAction from "@/hooks/useDisptachAction";
import { setUserInfo } from "@/redux/actions/home";
import Link from "next/link";
import host from "@/utils/host";
import useLanguage from "@/hooks/useLanguage";

const LogoutModal = ({ show, onCancel }) => {
  const {t} = useLanguage();
  const router = useRouter();
  const dispatchAction = useDispatchAction({ setUserInfo });
  
  return <Modal title={null} centered footer={null} width={618} open={show} onCancel={() => {
    onCancel();
  }}>
    <div>
      <div className={styles.create_link_page}>
        <img src={'/images/warning-tips-icon.svg'} className={"w-[60px] h-[60px]"} />
        <div className={"mt-[28px] text_222 text-[14px] text-center"}>
          {t('logout.message')} <span className={"font-bold "}>{t('logout.login_again')}</span> {t('logout.confirm')}
        </div>

        <div className={"flex items-center gap-[48px] w-full mt-[28px]"}>
          <CommonNormalBtn onClick={() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("token");
            dispatchAction.setUserInfo(null);
            router.push("/");
            onCancel();
          }}>{t('common.yes')}</CommonNormalBtn>
          <CommonPrimaryBtn onClick={() => {
            onCancel();
          }}>{t('common.no')}</CommonPrimaryBtn>
        </div>

      </div>
    </div>
  </Modal>;
};

export default LogoutModal;
